/* eslint-disable */
jQuery(function () {
  let body = jQuery('body')
    , $modal = jQuery('.form-modal')
    , $button = jQuery('.widget-contact__require')
    , $closeModal = jQuery('.icon-g-close, .form-modal__overlay')
    ;

  $modal.hide();

  $button.click(function (e) {
    body.addClass('no-scroll-form-modal');
    $modal.fadeIn('slow');
    e.stopPropagation();
  });

  $closeModal.click(function () {
    body.removeClass('no-scroll-form-modal');
    $modal.fadeOut('slow');
  });
});
